/*
 * Frank!y productpagina — gedrag voor snippets/frankly-pdp.liquid.
 * Geladen door sections/main-product.liquid (defer), zonder afhankelijkheden.
 *
 * 1. Meetpunten: klikken op elementen met data-frankly-meet gaan via
 *    Shopify.analytics.publish naar de Web Pixels, maar alleen met toestemming
 *    voor analytics. Zonder toestemming geen event, net als in frankly-skin-test.js.
 * 2. Sticky koopbalk op mobiel: zichtbaar zodra de hoofdknop niet in beeld is,
 *    behalve bij de footer of met een overlay van Dawn open (menu, zoeken,
 *    winkelwagenlade, fotoviewer). De balk klikt op de hoofdknop van Dawn;
 *    variant, winkelwagenlade en app-logica blijven dus precies die van Dawn.
 * 3. Tabbladen onder de foto's (reviews, ingrediënten, gebruik, natuurlijk en gerecycled),
 *    met het reviewwidget van Klaviyo Reviews in het eerste paneel (sinds
 *    15-10-2026; daarvoor Judge.me).
 * 4. Miniaturen: altijd 4 in beeld; bij wisselen schuift de strook mee.
 * 5. De voordeelregel (USP 1, met het F!-teken): boven de prijs op tablet en
 *    desktop, onder de geruststelling op mobiel. USP 2 en 3 staan vast in het
 *    hulpblok onder de haarlijn en verhuizen niet.
 */
(function () {
  'use strict';

  // Dawns quick-add zet de hele product-info in een modal en voert de scripts
  // daarin opnieuw uit. Eén keer per pagina is genoeg; anders telt elke klik dubbel.
  if (window.franklyPdpGeladen) return;
  window.franklyPdpGeladen = true;

  // ---------- meetpunten ----------

  // Geen buffer zoals in de huidtest: dit zijn losse klikken, geen trechter. Is de
  // stand van de toestemming nog niet bekend, dan gaat er niets weg.
  // Geeft true terug als het event echt is verstuurd.
  function meet(naam, data) {
    try {
      var p = window.Shopify && window.Shopify.customerPrivacy;
      if (!p || typeof p.analyticsProcessingAllowed !== 'function') return false;
      if (p.analyticsProcessingAllowed() !== true) return false;
      if (window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
        window.Shopify.analytics.publish(naam, data);
        return true;
      }
    } catch (err) {
      // Een meetpunt mag de pagina nooit ophouden.
    }
    return false;
  }

  // Per naam hoogstens één keer per paginaweergave: we willen weten óf iemand
  // klikt, niet hoe vaak. Pas afvinken na een echte verzending, zodat een klik
  // na een later gegeven toestemming nog telt.
  var gemeten = {};
  document.addEventListener('click', function (event) {
    var el = event.target && event.target.closest ? event.target.closest('[data-frankly-meet]') : null;
    if (!el) return;
    var naam = el.getAttribute('data-frankly-meet');
    if (!naam || gemeten[naam]) return;
    if (meet(naam, { handle: el.dataset.handle || '' })) gemeten[naam] = true;
  });

  // ---------- sticky koopbalk ----------

  function startSticky() {
    // Alleen de echte productpagina: een product-info uit quick-add krijgt van Dawn
    // data-original-section en een id met 'quickadd-'.
    var bar = document.querySelector('product-info[id^="MainProduct-"]:not([data-original-section]) [data-frankly-sticky]');
    var hoofd = document.querySelector('product-info[id^="MainProduct-"]:not([data-original-section]) .product-form__submit[name="add"]');
    if (!bar || !hoofd || !('IntersectionObserver' in window)) return;

    var knop = bar.querySelector('[data-frankly-sticky-knop]');
    if (!knop) return;
    // Alleen de zichtbare tekst wisselt; de visueel verborgen producttitel erachter
    // blijft staan, zodat de toegankelijke naam altijd met de zichtbare tekst begint.
    var label = knop.querySelector('[data-frankly-sticky-label]') || knop;

    // De balk staat in de markup binnen .product__info-wrapper. Die krijgt van de
    // scroll-animatie van Dawn (scroll-trigger animate--slide-in) een transform, en
    // een voorouder met een transform maakt position: fixed relatief aan zichzelf
    // in plaats van aan het scherm. Daarom hangen we de balk direct aan <body>.
    if (bar.parentNode !== document.body) document.body.appendChild(bar);

    var mq = window.matchMedia('(max-width: 749px)');
    var hoofdInBeeld = true;
    var footerInBeeld = false;
    var drawer = document.querySelector('cart-drawer');

    function drawerOpen() {
      return !!(drawer && drawer.classList.contains('active'));
    }

    // Menulade ('overflow-hidden-tablet'), zoekvenster, winkelwagenlade en
    // fotoviewer ('overflow-hidden') van Dawn zetten allemaal zo'n klasse op <body>.
    // De balk ligt met z-index 4 boven de header (3) en dus ook boven de menulade
    // daarin; zonder deze check dekte hij de onderste menu-items af en bleef hij
    // klikbaar.
    function overlayOpen() {
      return /(^|\s)overflow-hidden/.test(document.body.className) || drawerOpen();
    }

    function bijwerken() {
      bar.hidden = !(mq.matches && !hoofdInBeeld && !footerInBeeld && !overlayOpen());
      // Ruimte van de balk als scroll-padding: zo scrolt de browser een element dat
      // focus krijgt (Tab) of via scrollIntoView in beeld komt tot boven de balk, in
      // plaats van tot de onderrand, waar de balk eroverheen ligt.
      document.documentElement.style.scrollPaddingBottom = bar.hidden ? '' : bar.offsetHeight + 24 + 'px';
    }

    // De hoofdknop telt pas als 'in beeld' als minstens 60% ervan zichtbaar is, en
    // dan boven de onderste 80px, waar de balk komt (62px balk, 75px bij een titel
    // van twee regels, plus 12px marge).
    // Met de standaard drempel 0 was 1px knop al genoeg om de balk te verbergen,
    // terwijl er dan geen bruikbare knop in beeld stond.
    new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          hoofdInBeeld = entry.isIntersecting && entry.intersectionRatio >= 0.6;
        });
        bijwerken();
      },
      { threshold: [0, 0.6], rootMargin: '0px 0px -80px 0px' }
    ).observe(hoofd);

    var footer = document.querySelector('footer');
    if (footer) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          footerInBeeld = entry.isIntersecting;
        });
        bijwerken();
      }).observe(footer);
    }

    // Focus terug na de winkelwagenlade. Dawn onthoudt waarmee de lade openging
    // (drawer.activeElement) en zet de focus daar bij het sluiten terug, maar op dat
    // moment is de balk nog verborgen en mislukt dat: de focus bleef op de
    // onzichtbare lade staan. Daarom hier nog eens, nadat bijwerken() de balk weer
    // heeft getoond. Alleen als de focus nergens anders terecht is gekomen.
    var drawerWasOpen = drawerOpen();
    function drawerVeranderd() {
      var wasOpen = drawerWasOpen;
      drawerWasOpen = drawerOpen();
      bijwerken();
      if (!wasOpen || drawerWasOpen || drawer.activeElement !== knop) return;
      var actief = document.activeElement;
      if (actief && actief !== document.body && !drawer.contains(actief)) return;
      if (!bar.hidden) {
        knop.focus({ preventScroll: true });
      } else {
        hoofd.focus({ preventScroll: true });
      }
    }

    if ('MutationObserver' in window) {
      new MutationObserver(bijwerken).observe(document.body, { attributes: true, attributeFilter: ['class'] });
      if (drawer) {
        new MutationObserver(drawerVeranderd).observe(drawer, { attributes: true, attributeFilter: ['class'] });
      }
    }

    // Oudere Safari (voor 14) kent alleen addListener.
    if (typeof mq.addEventListener === 'function') {
      mq.addEventListener('change', bijwerken);
    } else if (typeof mq.addListener === 'function') {
      mq.addListener(bijwerken);
    }

    // Spiegel de hoofdknop: uitverkocht daar is uitverkocht hier.
    function spiegel() {
      knop.disabled = hoofd.disabled;
      label.textContent = hoofd.disabled ? 'Uitverkocht' : 'In winkelwagen';
    }
    if ('MutationObserver' in window) {
      new MutationObserver(spiegel).observe(hoofd, { attributes: true, attributeFilter: ['disabled'] });
    }
    spiegel();

    // Mislukt het toevoegen (bijvoorbeeld een voorraadgrens), dan zet Dawn de
    // melding bij de hoofdknop, en die staat buiten beeld zolang de balk er is. Na
    // een klik op de balk scrollen we die melding daarom in beeld en zetten we de
    // focus op de hoofdknop ernaast. subscribe en PUB_SUB_EVENTS komen uit Dawns
    // pubsub.js en constants.js (defer, in de head, dus al geladen).
    var laatsteKlik = 0;
    if (typeof window.subscribe === 'function') {
      var foutEvent =
        typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartError ? PUB_SUB_EVENTS.cartError : 'cart-error';
      window.subscribe(foutEvent, function (data) {
        if (!laatsteKlik || Date.now() - laatsteKlik > 10000) return;
        if (data && data.source && data.source !== 'product-form') return;
        laatsteKlik = 0;
        // Dawn publiceert de fout vlak voordat het de melding zichtbaar maakt.
        setTimeout(function () {
          var form = hoofd.closest('product-form');
          var melding = form && form.querySelector('.product-form__error-message-wrapper');
          var doel = melding && !melding.hidden ? melding : hoofd;
          var focusWasOpKnop = document.activeElement === knop;
          doel.scrollIntoView({ block: 'center' });
          if (focusWasOpKnop) hoofd.focus({ preventScroll: true });
        }, 0);
      });
    }

    knop.addEventListener('click', function () {
      if (hoofd.disabled === true) return;
      laatsteKlik = Date.now();
      hoofd.click();
    });

    bijwerken();
  }

  // ---------- tabbladen onder de foto's ----------

  // Tabs volgens het WAI-ARIA-patroon: pijltjes, Home en End wisselen, Tab gaat
  // naar het paneel. Op mobiel staat het blok onder de koopzone (bij
  // [data-frankly-tabs-anker]), op tablet en desktop onder de galerij.
  function startTabs() {
    var blok = document.querySelector('.product__media-wrapper [data-frankly-tabs], [data-frankly-tabs]');
    if (!blok) return;
    var mediakolom = blok.parentElement;
    var anker = document.querySelector('[data-frankly-tabs-anker]');
    var mq = window.matchMedia('(max-width: 749px)');

    function plaats() {
      if (mq.matches && anker) {
        if (blok.parentElement !== anker) anker.appendChild(blok);
      } else if (blok.parentElement !== mediakolom) {
        mediakolom.appendChild(blok);
      }
    }
    plaats();
    if (typeof mq.addEventListener === 'function') {
      mq.addEventListener('change', plaats);
    } else if (typeof mq.addListener === 'function') {
      mq.addListener(plaats);
    }

    var tabs = Array.prototype.slice.call(blok.querySelectorAll('[role="tab"]'));
    function kies(tab, focus) {
      tabs.forEach(function (t) {
        var aan = t === tab;
        t.setAttribute('aria-selected', aan ? 'true' : 'false');
        t.tabIndex = aan ? 0 : -1;
        var paneel = document.getElementById(t.getAttribute('aria-controls'));
        if (paneel) paneel.hidden = !aan;
      });
      if (focus) tab.focus();
    }
    tabs.forEach(function (tab, i) {
      tab.addEventListener('click', function () {
        kies(tab, false);
        meet('frankly_pdp_tab', { tab: tab.getAttribute('data-frankly-tab') });
      });
      tab.addEventListener('keydown', function (e) {
        var doel = null;
        if (e.key === 'ArrowRight') doel = tabs[(i + 1) % tabs.length];
        else if (e.key === 'ArrowLeft') doel = tabs[(i - 1 + tabs.length) % tabs.length];
        else if (e.key === 'Home') doel = tabs[0];
        else if (e.key === 'End') doel = tabs[tabs.length - 1];
        if (doel) {
          e.preventDefault();
          kies(doel, true);
        }
      });
    });

    // De sterren onder de productnaam openen het reviews-tabblad en scrollen erheen.
    var reviewsTab = blok.querySelector('[data-frankly-tab="reviews"]');
    if (reviewsTab) {
      Array.prototype.forEach.call(document.querySelectorAll('[data-frankly-naar-reviews]'), function (link) {
        link.addEventListener('click', function (e) {
          e.preventDefault();
          kies(reviewsTab, false);
          var rustig = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          blok.scrollIntoView({ behavior: rustig ? 'auto' : 'smooth', block: 'start' });
          reviewsTab.focus({ preventScroll: true });
          meet('frankly_pdp_sterren_klik', {});
        });
      });
    }

    // Het reviewwidget van Klaviyo Reviews (sinds 15-10-2026, daarvoor Judge.me)
    // is een losse app-sectie onder de pagina (app-blok 'product-reviews' in
    // templates/product*.json, sectie 'klaviyo_reviews'). We zetten het hele
    // app-blok in het reviewpaneel en verbergen de lege sectie. Lukt dat niet,
    // dan blijft het widget onder de pagina staan en linkt het paneel ernaartoe
    // (#klaviyo-product-reviews-wrapper, de wrapper die Klaviyo zelf rendert).
    var doel = blok.querySelector('[data-frankly-reviews-doel]');
    var widget =
      document.querySelector('.shopify-app-block[id*="klaviyo_reviews_product_reviews"]') ||
      document.getElementById('klaviyo-product-reviews-wrapper');
    if (doel && widget) {
      var sectie = widget.closest('.shopify-section');
      doel.textContent = '';
      doel.appendChild(widget);
      if (sectie && !sectie.contains(blok)) sectie.hidden = true;
    }
  }

  // ---------- miniaturen: altijd 4 in beeld, doorschuiven bij wisselen ----------

  // Dawn scrolt de strook alleen als de gekozen miniatuur buiten beeld valt, en dan
  // helemaal naar links. Hier schuift de strook zo dat de gekozen foto de tweede van
  // de vier is: de foto ervoor en de volgende blijven zichtbaar. Aan het begin en
  // eind stopt hij netjes op de eerste of laatste vier.
  function startMiniaturen() {
    var lijst = document.querySelector('product-info .thumbnail-slider .thumbnail-list');
    if (!lijst) return;
    var items = Array.prototype.slice.call(lijst.querySelectorAll('.thumbnail-list__item'));
    if (items.length <= 4) return;

    function schuif() {
      var actief = -1;
      items.forEach(function (item, i) {
        var knop = item.querySelector('button[aria-current]');
        if (knop) actief = i;
      });
      if (actief < 0) return;
      var eerste = Math.max(0, Math.min(actief - 1, items.length - 4));
      lijst.scrollTo({ left: items[eerste].offsetLeft - items[0].offsetLeft });
    }
    new MutationObserver(schuif).observe(lijst, {
      subtree: true,
      attributes: true,
      attributeFilter: ['aria-current'],
    });
  }

  // ---------- voordeelregel: boven de prijs, op mobiel onder de knop ----------

  // De voordeelregel ([data-frankly-usps], één regel met het F!-teken) staat in de
  // template tussen de kop en de prijs; zo staat hij op tablet en desktop. Op
  // mobiel gaat hij naar [data-frankly-usps-anker], onder de knop en de
  // geruststelling (retour, betaalregel): boven de prijs zou hij de knop nog
  // verder onder het eerste scherm duwen. Dezelfde verhuizing als bij de
  // tabbladen, maar de plek boven de prijs ligt midden in de kolom; een lege
  // commentaarnode onthoudt die, zodat de regel terug kan als het scherm breder
  // wordt (een tablet die je draait). Zonder anker blijft de regel staan waar hij
  // staat (de CSS verbergt hem dan ook niet op mobiel).
  //
  // Regel en anker worden bij elke plaatsing opnieuw opgezocht, niet één keer
  // onthouden: de theme-editor vervangt de hele sectie zodra je een blok versleept
  // of een instelling wijzigt, en voert dit script dan niet opnieuw uit. Met
  // onthouden elementen bleef de nieuwe regel in de mobiele voorvertoning boven de
  // prijs staan, en daar verbergt de CSS hem: geen voordeelregel meer tot je de
  // pagina herlaadt. Daarom luistert shopify:section:load mee. Elke regel krijgt
  // precies één markering (franklyPlek), dus vaker plaatsen verandert niets.
  var uspsMq = window.matchMedia('(max-width: 749px)');

  function plaatsUsps() {
    var basis = 'product-info[id^="MainProduct-"]:not([data-original-section]) ';
    var lijst = document.querySelector(basis + '[data-frankly-usps]');
    var anker = document.querySelector(basis + '[data-frankly-usps-anker]');
    if (!lijst || !anker) return;

    var plek = lijst.franklyPlek;
    if (!plek) {
      plek = document.createComment(' frankly-usps ');
      lijst.parentNode.insertBefore(plek, lijst);
      lijst.franklyPlek = plek;
    }

    if (uspsMq.matches) {
      if (lijst.parentElement !== anker) anker.appendChild(lijst);
    } else if (lijst.previousSibling !== plek) {
      plek.parentNode.insertBefore(lijst, plek.nextSibling);
    }
  }

  function startUsps() {
    plaatsUsps();
    if (typeof uspsMq.addEventListener === 'function') {
      uspsMq.addEventListener('change', plaatsUsps);
    } else if (typeof uspsMq.addListener === 'function') {
      uspsMq.addListener(plaatsUsps);
    }
    document.addEventListener('shopify:section:load', plaatsUsps);
  }

  // ---------- koopkolom sticky op desktop ----------

  // Dawn zet de koopkolom op top: 3rem. Is de kolom hoger dan het scherm, dan zou
  // de onderkant (beschrijving) pas aan het eind van de pagina zichtbaar worden.
  // Daarom: top = het kleinste van 48px en (schermhoogte - kolomhoogte - 24px).
  // Past hij, dan staat hij 48px onder de rand; past hij niet, dan schuift hij
  // eerst mee en blijft staan zodra zijn onderkant in beeld is.
  function startKolom() {
    var kolom = document.querySelector('.product__info-container.product__column-sticky');
    if (!kolom) return;
    function zet() {
      var top = Math.min(48, window.innerHeight - kolom.offsetHeight - 24);
      kolom.style.top = top + 'px';
    }
    zet();
    window.addEventListener('resize', zet);
    if (typeof ResizeObserver === 'function') new ResizeObserver(zet).observe(kolom);
  }

  function start() {
    // Eerst de USP's op hun plek, dan pas de kolom meten.
    startUsps();
    startKolom();
    startSticky();
    startTabs();
    startMiniaturen();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
